import axios from 'axios'
import qs from 'qs'

export const assessmentService = ({
  getAllAssessmentList (token) {
    return axios.get('/api/Assessment/GetAllV2', {headers: {'Authorization': 'Bearer ' + token}})
  },
  getAllAssessmentElementList (token, assessmentId) {
    return axios.get('/api/Assessment/ListElements?assessmentId=' + assessmentId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  createAssessment (token, assessmentObj) {
    return axios.post('/api/Assessment/Create', assessmentObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateAssessment (token, assessmentObj) {
    var stringifiedObj = qs.stringify(assessmentObj)
    return axios.put('/api/Assessment/Update', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteAssessment (token, assessmentId) {
    return axios.delete('/api/Assessment/Delete?assessmentId=' + assessmentId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  copyAssessment (token, assessmentId) {
    return axios.post('/api/Assessment/ImportAssessment?assessmentId=' + assessmentId, null, {headers: {'Authorization': 'Bearer ' + token}})
  }
})



// WEBPACK FOOTER //
// ./src/server-util/assessment-service.js